import { useMutation } from 'react-query'
import { axiosInstance, updateUserLanguage } from '../api/http'

export const useUserFunctions = () => {
  const resetPassword = useMutation(axiosInstance.mobile.usersControllerResetPassword)

  const changePassword = useMutation(axiosInstance.mobile.usersControllerUpdatePassword)

  const checkHasPassword = useMutation(axiosInstance.mobile.usersControllerCheckHasPassword)

  const acceptTerms = useMutation(axiosInstance.mobile.usersControllerAcceptTerms)

  const updateLanguage = useMutation(updateUserLanguage)

  return {
    resetPassword,
    changePassword,
    checkHasPassword,
    acceptTerms,
    updateLanguage,
  }
}

export const useUpdateLanguage = () => {
  const { updateLanguage } = useUserFunctions()
  return updateLanguage
}
